/* Built In Imports */
/* External Imports */
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  chakra,
} from '@chakra-ui/react';

import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import MidContainer from '@Layout/MidContainer';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import { title } from 'process';

/* Services */

/**
 * Renders the Faq Expanded Section component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Current User Country.
 * @param {string} lang - Current User Language.
 * @returns {ReactElement} FaqSectionV4 component
 */

const FaqSectionV4 = ({ sectionContent, region, lang, sectionId }) => {
  const title = sectionContent.title;
  return (
    <MidContainer
      px={{ base: '.5rem', md: '0' }}
      pt="2rem"
      pb={{ base: '2rem', md: '0' }}
      mb={{ md: '-3rem' }}
    >
      <Box pb={{ base: '1rem', md: '2.5rem' }}>
        <MsrSectionTitle
          titleObj={{
            titleDecoration: 'drums-above',
            titleSubtext: '',
            titleText: title,
          }}
          lang={lang}
        />
      </Box>
      <Box p={'0 10px'}>
        <Box mb={20} id="faq">
          <Accordion allowMultiple>
            {sectionContent?.faqs?.map((faq, ind) => {
              return (
                <AccordionItem
                  key={nanoid(4)}
                  px={{ base: '1rem', md: '0' }}
                  // borderBottomWidth="0.5px"
                  // borderBottomColor={
                  //   ind === sectionContent?.faqs?.length - 1
                  //     ? '#8F92C1'
                  //     : '#8F92C1'
                  // }
                  // borderBottomWidth={
                  //   ind === sectionContent?.faqs?.length - 1 ? '0' : '0.5px'
                  // }
                  borderBottom={
                    ind === sectionContent?.faqs?.length - 1
                      ? 'none'
                      : '0.5px solid #8F92C1'
                  }
                  borderBottomColor="#8F92C1"
                  borderTop="none"
                  //   lineHeight="1.61"
                >
                  <AccordionButton
                    px="0"
                    fontFamily="FedraSansStd-medium"
                    fontSize="1.1rem"
                    borderTop="none"
                    _hover={{ background: 'none' }}
                    _focus={{ shadow: 'transparent' }}
                  >
                    <chakra.div
                      class="faq-qn"
                      fontSize={{ base: '18px' }}
                      lineHeight={{ base: '24px', md: '22.5px' }}
                      flex="1"
                      textAlign="left"
                      key={nanoid(4)}
                      color="#FFF7E9"
                      py={{ base: '14px', md: '1rem' }}
                    >
                      {faq.question}
                    </chakra.div>
                    <AccordionIcon color={{ base: '#FFFFFF', md: '#DFCCA8' }} />
                  </AccordionButton>
                  <AccordionPanel
                    pb={2}
                    fontSize="1.1rem"
                    fontFamily="FedraSansStd-book"
                    lineHeight="1.61"
                    px="0"
                  >
                    <Box
                      display="block"
                      width="100%"
                      lineHeight={{ base: '26px' }}
                      fontSize={{ base: '1rem' }}
                      color="#FFFFFF"
                    >
                      <Box
                        color="#FFF7E9"
                        pb={{ base: '1rem', md: '1.4rem' }}
                        mr={{ md: '2rem' }}
                      >
                        {/* className="event-text */}
                        <StructuredTextParser
                          str={render(faq.answer)}
                          region={region}
                          lang={lang}
                          lineHeight={{ base: '26px' }}
                          fontSize={{ base: '1rem' }}
                          mt="0"
                          maxW="100%"
                        />
                      </Box>
                    </Box>
                  </AccordionPanel>
                  <style global jsx>
                    {`
                      .faq a {
                        color: #cf4520;
                      }
                      .faq span.setting:after {
                        font-family: fontawesome;
                        font-size: 1.6rem;
                        content: '\f013';
                        color: #fff;
                        background: rgba(31, 41, 55, var(--tw-bg-opacity));
                        border-radius: 18px;
                        padding: 7px 8px 6px;
                        --tw-bg-opacity: 1;
                        vertical-align: middle;
                      }
                      .faq ul {
                        padding-left: 1.5em;
                      }
                      .faq p {
                        padding-bottom: 20px;
                      }
                      #faq-expanded-new {
                        margin-bottom: 0px;
                        padding-top: 0px;
                      }
                      #faq-expanded-new section {
                        max-width: 610px;
                      }
                      #faq-expanded-new h2 {
                        font-size: 22px;
                        padding-bottom: 0px;
                      }
                      #faq-expanded-new button {
                        padding-top: 0px;
                      }
                      #faq-expanded-new button div {
                        padding-top: 0px;
                        color: #676055;
                        font-size: 18px;
                      }
                      #faq-expanded-new div {
                        margin-bottom: 0px;
                      }
                      #faq-expanded-new p {
                        color: #676055;
                      }
                    `}
                  </style>
                </AccordionItem>
              );
            })}
          </Accordion>
        </Box>
      </Box>
    </MidContainer>
  );
};

export default FaqSectionV4;
